import React, { useEffect, useState } from 'react'
import { Layout} from 'antd';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'

import PrivateRoute from '../../components/global/PrivateRoute'
import Menus from './Menus';
import logofull from '../../assets/logo.png'
import logocropped from '../../assets/logoCropped.png'
import HeaderMenu from './HeaderMenu';
import Articles from '../Articles/Articles';
import NotFound from '../NotFound'
import ArticlePage from '../Articles/ArticlePage'
import Services from '../Services/Services';
import ProductPage from '../Product/ProductPage';
import Profile from '../Profile/Profile';
import Education from '../Education/Education';
import Roadmap from '../Roadmap';
import Feed from '../Feed/Feed';

const { Header, Content, Sider } = Layout;

const Dashboard = ()=> {
  const { innerWidth: width, innerHeight: height } = window;
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  
  const [collapsed, setCollapsed] = useState();
  
  useEffect(() => {
      if(width < 700){
        setCollapsed(true);
      }
      else{
        setCollapsed(false);
      }
  }, []);
  
    return (
      <Layout>
        <Sider
          theme="light"
          collapsible
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
          collapsedWidth={40}
          style={{ alignContent: "center" }}
        >
          {collapsed ? (
            <img src={logocropped} alt="Logo" className="logo-crop" />
          ) : (
            <img src={logofull} alt="Logo" className="logo-full" />
          )}

          <Menus collapsed={collapsed}/>
        </Sider>
        <Layout>
          <Header >
            <HeaderMenu />
          </Header>

          <Content style={{ padding: 15, marginBottom:25 }}>
              <Switch>
                <Route path="/" component={Feed} exact/>
                <Route path="/roadmap" component={Roadmap} exact/>
                <Route path="/news" component={Articles} exact/>
                <Route path="/chart-breakdowns" component={Articles} exact/>
                <Route path="/psychology-mindset" component={Articles} exact/>
                <Route path="/article/:slug" component={ArticlePage} exact/>
                <Route path="/services" component={Services} exact/>
                <Route path="/purchase/:type/:id" component={ProductPage} exact/>
                <Route path="/course/:id" component={Education} exact/>
                <PrivateRoute path="/profile" component={Profile} exact/>
				        <Route component={NotFound}/>
              </Switch>
          </Content>
        </Layout>
      </Layout>
    );
}
export default Dashboard